import { useTranslation } from "react-i18next";
import { Button, message, Modal, Switch } from "antd";
import React, { useEffect, useState } from "react";
import useKeyword from "../../../../hooks/useKeyword";
import { getConfigBlockQuizEvaluate, postConfigBlockQuizEvaluate } from "../../../../service/course-construct/settingLessonCourse";

interface ConfigScoreModalProps {
	open: boolean;
	handleCancel: () => void
}


const ConfigScoreModal: React.FC<ConfigScoreModalProps> = ({ open, handleCancel }) => {
  const { t } = useTranslation();

	const [isChecked, setIsChecked] = useState<boolean>(false);
	const blockId = useKeyword("blockId");
	const onChange = (checked: boolean) => {
		setIsChecked(checked)
	};

	const postBlockQuizEvaluate = async () => {
		try {
			const payload = {
				courseBlockId: blockId,
				recordResults: isChecked ? 1 : null,
				automaticScoring: false,
				typeScore: null,
				minimumScore: null,
				scoreFactor: null,
				showResultsCompletion: false,
				showResultsCompletionOption: null

			}
			await postConfigBlockQuizEvaluate(payload).then((res) => {
				if (res.status === 200) {
					message.success(t("Lưu cài đặt thành công!", "Lưu cài đặt thành công!"));
					handleCancel()
				}
			})
		} catch (err) { }
	}

	console.log(isChecked);

	useEffect(() => {
		const fetchConfig = async () => {
			try {
				const res = await getConfigBlockQuizEvaluate(Number(blockId))
				const { data } = res?.data
				setIsChecked(data?.recordResults === "1" ? true : false)
			} catch (error) {

			}

		}
		if (open) fetchConfig()
	}, [open, blockId]);

	return (
		<Modal
			centered
			title={t("Cài đặt chấm điểm", "Cài đặt chấm điểm")}
			open={open}
			onCancel={handleCancel}
			footer={[
				<Button key="cancel"
					onClick={handleCancel}
				>
					{t("Hủy", "Hủy")}
				</Button>,
				<Button key="submit" type="primary" onClick={postBlockQuizEvaluate}>
					{t("Lưu", "Lưu")}
				</Button>,
			]}
		>
			<div className="flex align-center gap-16">
				{t("Bật ghi nhận kết quả vào thành tích", "Bật ghi nhận kết quả vào thành tích")} <Switch checked={isChecked} onChange={onChange} />
			</div>
		</Modal>
	);
};

export default ConfigScoreModal;
